/* Finsbury China: enhances the desktop dropdown menus.
   - Adds a one-line description under each link (matched by page URL)
   - Numbers the "Our process" steps
   - Adds a promo card on the right
   To change wording, edit the DESCRIPTIONS / PROMOS lists below. Links not listed just show their title. */
(function () {
  var DESCRIPTIONS = {
    '/pages/bespoke-orders': 'Your logo or design on fine bone china',
    '/pages/personalised-wedding-china': 'Monograms, crests and keepsakes for your day',
    '/pages/branded-hotel-restaurant-tableware': 'Branded crockery for hotels, restaurants and cafés',
    '/pages/corporate-gifts-branded-mugs': 'Branded mugs and gifts for clients and staff',
    '/pages/artists': 'Turn your artwork into fine bone china',
    '/pages/whiteware': 'Browse our whiteware range',
    '/pages/design': 'Artwork checks, sizing and colour',
    '/pages/printing': 'Silkscreen, spot colour and digital compared',
    '/pages/digital-printing': 'Order A3 transfer sheets online from £12',
    '/pages/decorating': 'Lithographing, banding and gilding by hand',
    '/pages/firing': 'How your design is fused into the glaze',
    '/pages/packaging-and-postage': 'Courier, pallet and international delivery'
  };

  // Keyed by the top-level menu title (lower case)
  var PROMOS = {
    'bespoke': {
      title: 'Free mockup & quote',
      text: 'Send us your logo or artwork and we’ll show you how it looks on fine bone china.',
      cta: 'Get started →',
      href: '/pages/bespoke-orders#quote'
    },
    'our process': {
      title: 'Just need transfer sheets?',
      text: 'Upload your A3 artwork and order digital ceramic transfers online, from £12 a sheet.',
      cta: 'Order digital printing →',
      href: '/pages/digital-printing',
      numbered: true
    }
  };

  function pathOf(a) {
    try { return new URL(a.href, location.origin).pathname.replace(/\/$/, ''); } catch (e) { return ''; }
  }

  function enhance() {
    if (window.FC_MENU_DEBUG) console.log('[fc-menu] enhance');
    var grids = document.querySelectorAll('.menu-list__submenu .mega-menu__grid');
    grids.forEach(function (grid) {
      if (grid.classList.contains('fc-mm')) return;
      var item = grid.closest('.menu-list__list-item');
      var topTitle = item && item.querySelector('.menu-list__link-title');
      var key = topTitle ? topTitle.textContent.trim().toLowerCase() : '';
      var promo = PROMOS[key];
      var links = grid.querySelectorAll('.mega-menu__list .mega-menu__link');
      if (!links.length) return;

      grid.classList.add('fc-mm');
      var cols = links.length <= 4 ? links.length : (links.length === 5 ? 5 : 3);
      grid.style.setProperty('--fc-cols', cols);

      links.forEach(function (a, i) {
        var label = a.textContent.trim();
        var desc = DESCRIPTIONS[pathOf(a)];
        var html = '';
        if (promo && promo.numbered) html += '<span class="fc-mm-num">' + (i < 9 ? '0' : '') + (i + 1) + '</span>';
        html += '<span class="fc-mm-title"></span>';
        if (desc) html += '<span class="fc-mm-desc"></span>';
        a.innerHTML = html;
        a.querySelector('.fc-mm-title').textContent = label;
        if (desc) a.querySelector('.fc-mm-desc').textContent = desc;
        if (pathOf(a) === location.pathname.replace(/\/$/, '')) a.setAttribute('aria-current', 'page');
      });

      if (promo) {
        var p = document.createElement('a');
        p.className = 'fc-mm-promo';
        p.href = promo.href;
        p.innerHTML = '<div><strong></strong><span></span></div><em></em>';
        p.querySelector('strong').textContent = promo.title;
        p.querySelector('span').textContent = promo.text;
        p.querySelector('em').textContent = promo.cta;
        grid.appendChild(p);
      }
    });
  }

  // The theme re-renders the header menu after load, so re-apply whenever it changes.
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; enhance(); });
  }
  function start() {
    enhance();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    // Safety net: re-check a few times while the page settles
    [500, 1500, 3000].forEach(function (t) { setTimeout(enhance, t); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
